import { Paging } from '../shared-typed'
import { EnumTransactionStatus, EnumTransactionType, Transaction } from '../transaction/transaction-typed'

import { User } from '../user/user-typed'

export enum DcaPlanState {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum EnumFrequencyDcaType {
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
}

export type Port = {
  createdAt: string
  deletedAt: string
  id: string
  kycId: string
  sgGoldBalance: string
  sgMobileNo: string
  sgPincode: string
  sgUserId: string
  updatedAt: string
  user: User
  userId: string
  transactions: Transaction[]
}

export type DcaPlans = {
  portId: string
  date: Number
  value: string
  status: DcaPlanState
  type: EnumFrequencyDcaType
  externalReference?: string
  port?: Port
  user?: User
  id: string
  createdAt: string
  updatedAt: string
  subscriptionId?: string
}


export type DcaList = {
  items: DcaPlans[]
  meta: Paging
}

export type TransactionDcaPlan = {
  id:string
  txId:string
  status: EnumTransactionStatus
  price: string
  type: EnumTransactionType
  createdAt: string
  subscriptionId?:string
  dcaReference: string
  dcaType?: EnumFrequencyDcaType
  dcaDate?: number
}

export type TransactionsDcaPlanList = {
  items: TransactionDcaPlan[]
  meta: Paging
}
